import { addDays } from 'date-fns';
import { Response } from 'miragejs';
import { EnqueteType, GetSurveyChatResult, GetSurveyChatsResult, GetSurveyResult } from '../api';
import { AppErrorKeys } from '../errors/error';
import { getErrorResponse, getSuccessEmptyResponse } from './common';

export const MOCK_GET_SURVEY: { OK: (alreadyAnsweredToday: boolean) => GetSurveyResult; KO: Response } = {
  OK: (alreadyAnsweredToday: boolean) => ({
    questions: [{ id: 1, question: "Parlez-nous de votre passage dans ce restaurant. C'était plutôt ..." }],
    type: EnqueteType.Complete,
    note: { totalVotes: Math.round(1 + Math.random() * 50), value: 4.5 },
    alreadyAnsweredToday,
  }),
  KO: getErrorResponse(AppErrorKeys.AnErrorOccured),
};

export const MOCK_REPLY_TO_SURVEY: { OK: Response; KO: Response } = {
  OK: getSuccessEmptyResponse(),
  KO: getErrorResponse(AppErrorKeys.AnErrorOccured),
};

export const MOCK_SURVEY_RESPONSE_OK: GetSurveyChatResult = {
  id: 1,
  conviveComment: 'Super repas, je me suis régalé',
  conviveCommentDate: new Date().toISOString(),
  managerComment: 'Merci de ce commentaire, nous apprécions',
  managerCommentDate: new Date().toISOString(),
  note: '4',
  restaurantLibelle: 'Wonderfood',
};

export const MOCK_GET_CHAT: { OK: GetSurveyChatResult; KO: Response } = {
  OK: MOCK_SURVEY_RESPONSE_OK,
  KO: getErrorResponse(AppErrorKeys.AnErrorOccured),
};

function createChat(
  id: number,
  conviveComment: string,
  conviveCommentDate: Date,
  managerComment: string,
  managerCommentDate: Date,
  note: string,
  restaurantLibelle?: string,
) {
  const chat: GetSurveyChatResult = {
    id,
    conviveComment,
    conviveCommentDate: conviveCommentDate.toString(),
    managerComment,
    managerCommentDate: managerCommentDate.toString(),
    note,
    restaurantLibelle,
  };
  return chat;
}

const PROPS = [
  {
    conviveComment: 'Super repas, je me suis régalé',
    conviveCommentDate: new Date().toISOString(),
    managerComment: 'Merci de ce commentaire, nous apprécions',
    managerCommentDate: new Date().toISOString(),
    note: '4',
    restaurantLibelle: 'Wonderfood',
  },
  {
    conviveComment: 'Le poisson était froid',
    conviveCommentDate: addDays(new Date(), -1).toISOString(),
    managerComment: "Désolé de l'apprendre, nous prenons en compte votre avis",
    managerCommentDate: addDays(new Date(), -1).toISOString(),
    note: '1',
    restaurantLibelle: "L'escale",
  },
  {
    conviveComment: 'Vous pourriez ajouter des portions plus importantes sur vos plats',
    conviveCommentDate: addDays(new Date(), -2).toISOString(),
    managerComment: "Nous prenons en compte votre avis, n'hésitez pas à le remonter au moment du service",
    managerCommentDate: addDays(new Date(), -2).toISOString(),
    note: '2',
    restaurantLibelle: "R'Food",
  },
  {
    conviveComment: "Super repas, j'ai bien aimé le poisson",
    conviveCommentDate: addDays(new Date(), -3).toISOString(),
    managerComment: 'Merci de ce commentaire, nous apprécions',
    managerCommentDate: addDays(new Date(), -3).toISOString(),
    note: '5',
  },
];

function createChats() {
  const today = new Date();
  const chats: GetSurveyChatResult[] = [];
  for (let i = 0; i < 13; i++) {
    const props = PROPS[i % 4];
    chats.push(createChat(i, props.conviveComment, addDays(today, -i - 1), props.managerComment, addDays(today, -i), props.note, props.restaurantLibelle));
  }
  return chats;
}

export const MOCK_GET_CHAT_RESPONSES_OK_PAGE0: GetSurveyChatsResult = {
  hasMore: true,
  surveyChats: createChats().slice(0, 9),
};

export const MOCK_GET_CHAT_RESPONSES_OK_PAGE1: GetSurveyChatsResult = {
  hasMore: false,
  surveyChats: createChats().slice(10, 12),
};

export const MOCK_GET_CHATS = {
  OK_PAGE0: MOCK_GET_CHAT_RESPONSES_OK_PAGE0,
  OK_PAGE1: MOCK_GET_CHAT_RESPONSES_OK_PAGE1,
  KO: getErrorResponse(AppErrorKeys.AnErrorOccured),
};
